import { PurseStackingOrderListState } from "@/admin/types";
import { FetchState } from "@/shared/types";
import _ from "lodash";
import { defineStore } from "pinia";
import * as cardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

export const initialState: PurseStackingOrderListState = {
    purseStackingOrders: [],
    fetchState: FetchState.Uninitialized
};

export const usePurseStackingOrderListStore = defineStore("purseStackingOrderList", {
    state: () => (_.cloneDeep(initialState)),
    actions: {
        loadPurseStackingOrderList () {
            const featureFlagStore = useFeatureFlagStore();
            if (this.fetchState !== FetchState.Uninitialized) {
                return;
            }

            this.fetchState = FetchState.Loading;

            cardService.listPurseStackingOrders()
                .then(response => {
                    this.purseStackingOrders = response.data.purseStackingOrderModels;
                    this.fetchState = FetchState.Loaded;
                })
                .catch(error => {
                    this.fetchState = FetchState.Uninitialized;
                    storeHelper.handleError({ error, rethrow: true });
                });
        }
    }
});